import type { ProposalBuilderConfig } from '@/types/schema/page-configs/proposal-builder'

export const defaultProposalBuilderConfig: ProposalBuilderConfig = {
  investmentGuidelines: `- Max sector concentration of 20% for corporates and municipals. 
- Max issuer concentration of 10% for corporates and municipals. 
- Min rating of BBB.
- Average rating of A- for corporates and AA for municipals.
- Min 1 month to maturity.
- Target 20 bonds for corporate and municipal allocations.
- No taxable municipals.
- No private placements or sinkable bonds.
- Minimum 50% in general obligation for municipals.
- Max state concentration of 10% for national muni portfolios.`,
}
